import { AppPreferredPlayerPosition } from '@core-http';

export const preferredPositionMapper: Record<AppPreferredPlayerPosition, string> = {
  [AppPreferredPlayerPosition.GOALKEEPER]: 'Bramkarz',
  [AppPreferredPlayerPosition.BACK]: 'Obrońca',
  [AppPreferredPlayerPosition.MIDFIELDER]: 'Pomocnik',
  [AppPreferredPlayerPosition.STRIKER]: 'Napastnik'
};
